export default class LockTableDayInfo {
    constructor(date, working, runnerOver, hasLockedInvisibleUser, hasUnlockedInvisibleUser) {
        this.date = date;
        this.working = working;
        this.runnerOver = runnerOver;
        this.hasLockedInvisibleUser = hasLockedInvisibleUser;
        this.hasUnlockedInvisibleUser = hasUnlockedInvisibleUser;
    }
}



// WEBPACK FOOTER //
// ./web/js/locktable/model/LockTableDayInfo.js